const getCouponRoot = (element) => element.closest('.cart-drawer__inner');

const getSheet = (root) => root?.querySelector('[data-cart-coupon-sheet]');

const getSheetInput = (root) => getSheet(root)?.querySelector('[data-cart-coupon-sheet-input]');

const getSheetForm = (root) => getSheetInput(root)?.closest('form');

let shouldReopenSheet = false;

const openSheet = (sheet) => {
  if (!(sheet instanceof HTMLElement)) return;
  sheet.hidden = false;
  const input = sheet.querySelector('[data-cart-coupon-sheet-input]');
  if (input instanceof HTMLInputElement) {
    queueMicrotask(() => input.focus());
  }
};

const closeSheet = (sheet) => {
  if (!(sheet instanceof HTMLElement)) return;
  sheet.hidden = true;
};

const scheduleSheetReopen = () => {
  window.setTimeout(() => {
    if (!shouldReopenSheet) return;

    const sheet = document.querySelector('.cart-drawer__inner [data-cart-coupon-sheet]');
    openSheet(sheet);
    shouldReopenSheet = false;
  }, 180);
};

const submitCouponCode = (root, couponCode) => {
  if (!(root instanceof HTMLElement) || !couponCode) return;

  const input = getSheetInput(root);
  const form = getSheetForm(root);

  if (!(input instanceof HTMLInputElement) || !(form instanceof HTMLFormElement)) return;

  input.value = couponCode;

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
  } else {
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }
};

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const removeTrigger = target.closest('.cart-coupon-sheet .cart-discount__pill-remove');
  if (removeTrigger instanceof HTMLElement) {
    shouldReopenSheet = true;
    scheduleSheetReopen();
  }

  const openTrigger = target.closest('[data-cart-coupon-trigger]');
  if (openTrigger instanceof HTMLElement) {
    const root = getCouponRoot(openTrigger);
    openSheet(getSheet(root));
    return;
  }

  const closeTrigger = target.closest('[data-cart-coupon-close]');
  if (closeTrigger instanceof HTMLElement) {
    const root = getCouponRoot(closeTrigger);
    shouldReopenSheet = false;
    closeSheet(getSheet(root));
    return;
  }

  const applyTrigger = target.closest('[data-cart-coupon-apply]');
  if (applyTrigger instanceof HTMLElement) {
    const root = getCouponRoot(applyTrigger);
    const couponCode = applyTrigger.dataset.couponCode || '';
    submitCouponCode(root, couponCode);
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-cart-coupon-sheet-form]')) return;

  shouldReopenSheet = true;
  scheduleSheetReopen();
});
